import { DisplayPosition } from '@/type/display-position';
import { CnImageViewer } from '@cainiaofe/cn-ui-m';
import isPlainObject from 'lodash/isPlainObject';
export default {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.cnArrayTable,
    ],
    title: '图片预览',
    componentName: 'CnImageViewer',
    formComponent: CnImageViewer,
    getDefaultProps: () => {
        return {};
    },
    getPrototypeList: () => {
        return [
            {
                title: '单张图片展示样式',
                name: 'single',
                defaultValue: false,
                display: 'inline',
                setter: 'BoolSetter',
            },
        ];
    },
    formItemBeforeHandler: (formItem, config) => {
        const { isDesign, urlParams, formValue, formItemConfig, state } = config;
        const name = formItemConfig?.name;
        const value = formValue?.[name];
        const single = formItemConfig?.options?.single;
        const componentProps = formItem['x-component-props'];
        if (isPlainObject(componentProps)) {
            componentProps.src = value;
            componentProps.single = single;
        }
    },
};
